import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";

const ConfirmUnderwrite = ({
  handleSubmit,
  prompt,
  title = "Confirm ",
  titleStyle = "fs-3 text-center",
  promptStyle = "lh-sm fs-6",
  buttonText = "Ok",
  isTitle,
}) => {
  const closeRef = useRef();

  const navigate = useNavigate();

  return (
    <div className='container'>
      {isTitle ? <h2 className={titleStyle}>{title}</h2> : null}
      <div className='my-3 text-center'>
        <p className={promptStyle}>{prompt}</p>
      </div>
      <div className='d-flex justify-content-between'>
        <div className='d-grid'>
          <button
            ref={closeRef}
            className='btn btn-sm mt-2 px-3 text-muted'
            data-bs-dismiss='modal'
            style={{ background: "#F1F0F1" }}
          >
            Cancel
          </button>
        </div>
        <div className='d-grid'>
          <button
            onClick={() => {
              handleSubmit();
              closeRef.current.click();
            }}
            className='btn btn-primary btn-sm mt-2 px-3 text-white'
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmUnderwrite;
